class BlogFilter extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      section: this.closest(".shopify-section"),
      details: this.querySelector("details"),
      summary: this.querySelector("summary"),
      labels: this.querySelectorAll("label"),
      inputs: this.querySelectorAll("input"),
    };
  }

  connectedCallback() {
    this.scrollToBlogPosts();

    this.elements.inputs.forEach((input) => {
      input.addEventListener("change", this.onInputChange.bind(this));
    });

    this.elements.labels.forEach((label) => {
      label.addEventListener("keydown", this.onLabelKeyed.bind(this));
    });

    document.addEventListener("click", (e) => {
      if (!this.contains(e.target)) {
        this.closeDetails();
      }
    });

    // Listen for ESC key on the whole component
    this.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && this.elements.details.hasAttribute("open")) {
        this.closeDetails();
        this.elements.summary.focus();
      }
    });
  }

  onInputChange(e) {
    const el = e.target;
    if (!el.value || !el.checked) return;
    el.closest("label").setAttribute("aria-busy", "true");
    if (el.dataset.linkToAdd) {
      window.location = el.dataset.linkToAdd;
    } else {
      window.location = el.value;
    }
  }

  onLabelKeyed(e) {
    if (e.key === "Enter" || e.key === "") {
      e.preventDefault();
      const input = e.target.querySelector("input");
      input.checked = true;
      input.dispatchEvent(new Event("change"));
    }
  }

  scrollToBlogPosts() {
    if (window.location.pathname.includes("/tagged/")) {
      this.elements.section.scrollIntoView({
        behavior: "smooth",
      });
    }
  }

  closeDetails() {
    this.elements.details.open = false;
  }
}

if (customElements.get("blog-filter") === undefined) {
  customElements.define("blog-filter", BlogFilter);
}
